import { convertValues } from '~/util';

import { client } from './client';
import { PlatformRoleName } from './UserRepository';

export interface Invite {
  email: string;
  createdAt?: Date;
  expiredAt?: Date;
  platformId: string;
  platformRole: string;
  createdBy: string;
  platformName: string;
}

export interface CreatePlatformInviteRequest {
  email: string;
  platformId: string;
  platformRole?: PlatformRoleName;
  roleId?: string;
}

export interface ListInvitesResponse {
  invites: Invite[];
}

export interface ListPlatformInvitesRequest {
  platformId: string;
}

export interface DeleteInviteRequest {
  platformId: string;
  email: string;
}

export interface ResendInviteEmailRequest {
  email: string;
}

export class InviteRepository {
  static async getAll({ platformId }: ListPlatformInvitesRequest) {
    return client.get<unknown, ListInvitesResponse>('/dashboard/invites', { platformId }).then((response) => ({
      invites: Array.isArray(response?.invites) ? response.invites.map((e) => convertValues<Invite>(e)) : [],
    }));
  }

  static async create(request: Partial<CreatePlatformInviteRequest>) {
    return client
      .post<Partial<CreatePlatformInviteRequest>, Invite>(
        `/dashboard/invites/platforms/${request.platformId}`,
        request,
        {
          platformId: request.platformId,
        }
      )
      .then((response) => convertValues<Invite>(response));
  }

  static async resend(email: string, platformId?: string) {
    return client.post<ResendInviteEmailRequest, object>('/dashboard/invites/resend_email', { email }, { platformId });
  }

  static async delete(platformId: string, email: string) {
    return client.delete<DeleteInviteRequest, object>(
      `/dashboard/invites/platforms/${platformId}/email/${encodeURIComponent(email)}`,
      {
        platformId,
      }
    );
  }
}
